import React from 'react';
import {ArrowRightCircle, Check, Circle} from "react-feather";

export function OnboardingSteps({currentStep = 0, steps = [], padding = 'py-16', className = ''}) {

  const StepIcon = ({index}) => {
    if (currentStep === index) return <ArrowRightCircle className="inline-block mr-2"/>
    if (currentStep > index) return <Check className="inline-block mr-2"/>
    if (currentStep < index) return <Circle className="inline-block mr-2"/>

    return null;
  }

  return <ul className={`flex md:justify-center ${padding} ${className}`}>
    {
      steps.map((step, index) => {
        return <li key={`index_${index}`} className={`text-lg font-bold mx-2 ${currentStep >= index ? '' : 'text-slate'} ${index === steps.length - 1 ? '' : 'after:inline-block md:after:ml-4 md:after:w-4 md:after:border after:border-slate after:relative after:-top-1'}`}>
          <StepIcon index={index}/>
          <span className={`${currentStep !== index ? 'hidden' : ''} md:inline-block`}>
            {step}
          </span>
        </li>
      })
    }
  </ul>
}
